import { render } from "./chevron.vue?vue&type=template&id=70c05799"
import script from "./chevron.vue?vue&type=script&lang=js"
export * from "./chevron.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__